import { render } from "./ConsultaUsuarios.vue?vue&type=template&id=3bb796ce"
import script from "./ConsultaUsuarios.vue?vue&type=script&lang=js"
export * from "./ConsultaUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__